import { getClassesForSurvey, getUsersForSurvey } from '../../services/data-entry/surveys.service';

export const UPDATE_SURVEYS_BUILDER_LIST = 'UPDATE_SURVEYS_BUILDER_LIST';
export const TOGGLE_SURVEYS_BUILDER_LIST_LOADING = 'TOGGLE_SURVEYS_BUILDER_LIST_LOADING';
export const SURVEYS_BUILDER_LIST_ERROR = 'SURVEYS_BUILDER_LIST_ERROR';
export const UPDATE_SURVEYS_BUILDER_USERS_LIST = 'UPDATE_SURVEYS_BUILDER_USERS_LIST';
export const UPDATE_SURVEYS_BUILDER_CLASSES_LIST = 'UPDATE_SURVEYS_BUILDER_CLASSES_LIST';
export const UPDATE_SURVEYS_BUILDER_FILTERED_USERS = 'UPDATE_SURVEYS_BUILDER_FILTERED_USERS';
export const UPDATE_SURVEYS_BUILDER_FILTERED_CLASSES = 'UPDATE_SURVEYS_BUILDER_FILTERED_CLASSES';
export const UPDATE_SURVEYS_BUILDER_TEMPLATE = 'UPDATE_SURVEYS_BUILDER_TEMPLATE';
export const SURVEY_USERS_CHECKED_IDS = 'USERS_CHECKED_STUDENTS_IDS';
export const UPDATE_SURVEY = 'UPDATE_SURVEY';
export const RESET_SURVEY_BUILDER_STATE = 'RESET_SURVEY_BUILDER_STATE';
export const SURVEY_BUILDER_UPDATE_TOTAL_LIST = 'SURVEY_BUILDER_UPDATE_TOTAL_LIST';

export const updateSurverysBuilderClassList = (value = []) => ({
  type: UPDATE_SURVEYS_BUILDER_CLASSES_LIST,
  payload: { name: 'classesList', value }
});

export const updateSurverysBuilderUsersList = (value = []) => ({
  type: UPDATE_SURVEYS_BUILDER_USERS_LIST,
  payload: { name: 'usersList', value }
});

export const updateSurveysBuilderFilteredUsers = (value = []) => ({
  type: UPDATE_SURVEYS_BUILDER_FILTERED_USERS,
  payload: { name: 'filteredUsers', value }
});
export const updateSurveysBuilderFilteredClasses = (value = []) => ({
  type: UPDATE_SURVEYS_BUILDER_FILTERED_CLASSES,
  payload: { name: 'filteredClasses', value }
});
export const updateSurveysBuilderTemplate = (value = []) => ({
  type: UPDATE_SURVEYS_BUILDER_TEMPLATE,
  payload: { name: 'template', value }
});

export const updateSurveysBuilderList = (value = []) => ({
  type: UPDATE_SURVEYS_BUILDER_LIST,
  payload: { name: 'list', value }
});

export const surveysBuilderListError = (value = null) => ({
  type: SURVEYS_BUILDER_LIST_ERROR,
  payload: { name: 'error', value }
});

export const toggleLoadingSurveysBuilder = (value = false) => ({
  type: TOGGLE_SURVEYS_BUILDER_LIST_LOADING,
  payload: { name: 'loading', value }
});

export const checkedUserIds = (ids = []) => ({
  type: SURVEY_USERS_CHECKED_IDS,
  ids
});

export const updateSurveyBuilder = (payload = {}) => ({
  type: UPDATE_SURVEY,
  payload: { ...payload }
});

export const resetSurveyBuilder = (payload = {}) => ({
  type: RESET_SURVEY_BUILDER_STATE,
  payload: {}
});

export const updateSurveyUsersTotalList = (name = 'totalList', total = 0) => ({
  type: SURVEY_BUILDER_UPDATE_TOTAL_LIST,
  name,
  total
});

export const loadUsersForSurvey = (skip = 0, limit = 50, filter = {}, surveyId = '') => {
  return async (dispatch) => {
    try {
      if (filter.hasOwnProperty('roles')) {
        delete filter.roles;
      }

      dispatch(toggleLoadingSurveysBuilder(true));
      dispatch(surveysBuilderListError({}));
      dispatch(updateSurverysBuilderUsersList([]));

      const { data } = await getUsersForSurvey(skip, limit, filter, surveyId);

      if (data) {
        dispatch(updateSurveyUsersTotalList('totalList', data?.totalRecords ?? 0));
        dispatch(updateSurveyUsersTotalList('totalFilterList', data?.totalFilter ?? 0));
        dispatch(updateSurverysBuilderUsersList(data?.paginatedResults ?? []));
      } else {
        dispatch(updateSurveyUsersTotalList('totalList', 0));
        dispatch(updateSurveyUsersTotalList('totalFilterList', 0));
        dispatch(updateSurverysBuilderUsersList([]));
        dispatch(updateSurveysBuilderList([]));
      }
    } catch (error) {
      dispatch(updateSurveyUsersTotalList('totalList', 0));
      dispatch(updateSurveyUsersTotalList('totalFilterList', 0));
      dispatch(updateSurverysBuilderUsersList([]));
      dispatch(updateSurveysBuilderList([]));
    } finally {
      dispatch(toggleLoadingSurveysBuilder());
      dispatch(surveysBuilderListError({}));
    }
  };
};

export const loadClassForSurvey = (skip = 0, limit = 50, filter = {}, surveyId = '') => {
  return async (dispatch) => {
    try {
      if (filter.hasOwnProperty('roles')) {
        delete filter.roles;
        delete filter.rolesId;
      }

      dispatch(toggleLoadingSurveysBuilder(true));
      dispatch(surveysBuilderListError({}));
      dispatch(updateSurverysBuilderClassList([]));

      const { data } = await getClassesForSurvey(skip, limit, filter, surveyId);

      if (data) {
        dispatch(updateSurveyUsersTotalList('totalList', data?.totalRecords ?? 0));
        dispatch(updateSurveyUsersTotalList('totalFilterList', data?.totalFilter ?? 0));
        dispatch(updateSurverysBuilderClassList(data?.paginatedResults ?? []));
      } else {
        dispatch(updateSurveyUsersTotalList('totalList', 0));
        dispatch(updateSurveyUsersTotalList('totalFilterList', 0));
        dispatch(updateSurverysBuilderClassList([]));
        dispatch(updateSurveysBuilderList([]));
      }
    } catch (error) {
      dispatch(updateSurveyUsersTotalList('totalList', 0));
      dispatch(updateSurveyUsersTotalList('totalFilterList', 0));
      dispatch(updateSurverysBuilderClassList([]));
      dispatch(updateSurveysBuilderList([]));
    } finally {
      dispatch(toggleLoadingSurveysBuilder());
      dispatch(surveysBuilderListError({}));
    }
  };
};
